/**
 * Product ingredients (Bevimi) — slide-up panel per ingredient item
 * Panel lives inside each item and slides up from the bottom of that card.
 * The plus icon in the card header toggles open/close and rotates to X when open.
 */
(function () {
  const selector = '.product-ingredients-bevimi';
  const itemSelector = '.product-ingredients-bevimi__item';
  const panelSelector = '.product-ingredients-bevimi__panel';
  const plusSelector = '.product-ingredients-bevimi__item-plus';
  const openClass = 'product-ingredients-bevimi__panel--open';
  const itemOpenClass = 'product-ingredients-bevimi__item--panel-open';
  const mobileQuery = '(max-width: 749px)';

  function init(container) {
    if (!container) return;

    container.querySelectorAll(itemSelector).forEach(function (item) {
      const panel = item.querySelector(panelSelector);
      const plus = item.querySelector(plusSelector);
      if (!panel) return;

      function openPanel() {
        panel.classList.add(openClass);
        item.classList.add(itemOpenClass);
        item.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }

      function closePanel() {
        panel.classList.remove(openClass);
        item.classList.remove(itemOpenClass);
        item.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      }

      function togglePanel() {
        if (panel.classList.contains(openClass)) closePanel();
        else openPanel();
      }

      function isMobileViewport() {
        return window.matchMedia(mobileQuery).matches;
      }

      item.addEventListener('click', function (e) {
        e.preventDefault();
        if (e.target.closest(plusSelector)) {
          togglePanel();
          return;
        }
        if (panel.classList.contains(openClass)) {
          if (isMobileViewport() && e.target.closest(panelSelector)) {
            closePanel();
          }
          return;
        }
        openPanel();
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (e.target.closest(plusSelector)) {
            togglePanel();
            return;
          }
          if (panel.classList.contains(openClass)) return;
          openPanel();
        }
      });

      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });
    });

    /* Close open panel when clicking outside the ingredient item */
    document.addEventListener('click', function (e) {
      container.querySelectorAll(itemSelector + '.' + itemOpenClass).forEach(function (item) {
        if (!item.contains(e.target)) {
          const panel = item.querySelector(panelSelector);
          if (panel) {
            panel.classList.remove(openClass);
            item.classList.remove(itemOpenClass);
            item.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
          }
        }
      });
    });
  }

  document.querySelectorAll(selector).forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector(selector);
    if (section) init(section);
  });
})();
